// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__39QZG","actions":"GroupTable_actions__2ksNb","deleteModalFooter":"GroupTable_deleteModalFooter__3dVnd"};